import React from 'react';

import { Box, Container, Typography } from '@mui/material';
import cx from 'classnames';

import { BREAKPOINTS_VALUES } from '../../theme';
import { useIsIE } from '../../utils/hooks';
import IKImage from '../IKImage/IKImage';
import { LazyLoadImage } from '../LazyloadImage';
import { Button } from '../UI/Button';
import useStyles from './styles';

const WhyUsWideImgBlock = ({ data }) => {
  const background = data?.background;
  const desktopImg = data?.desktop_image;
  const heading = typeof data?.heading === 'string' ? data?.heading : data?.heading?.en;
  const buttonUrl = data?.button_url;
  const buttonText = data?.button_text;
  const items = data?.items;

  const classes = useStyles(background)();
  const isIE = useIsIE();

  if (!items || items.length === 0) return null;

  return (
    <Box className={cx(classes.wrapper, background === 'Dark' ? 'dark-block' : 'light-block')}>
      <Container className={classes.container}>
        <Box className={classes.content}>
          <Typography variant="h2" component="h2" className={classes.heading}>
            {heading}
          </Typography>

          <Box className={classes.items}>
            {items &&
              items.map((item, index) => {
                const heading =
                  typeof item?.heading === 'string' ? item?.heading : item?.heading?.en;
                const description =
                  typeof item?.description === 'string' ? item?.description : item?.description?.en;

                return (
                  <div key={index} className={cx(classes.item, 'image-array-block__item')}>
                    <div className={classes.imageWrap}>
                      <IKImage
                        path={item.image}
                        draggable={false}
                        alt={heading}
                        srcset={[{ width: 65 }, { width: 50 }]}
                        sizes={`(max-width:${BREAKPOINTS_VALUES['md']}px) 65px, 50px`}
                      />
                    </div>
                    <div className={classes.textWrapper}>
                      <Typography variant="h3" component="h3" className={classes.itemTitle}>
                        {heading}
                      </Typography>
                      <Typography className={classes.itemText}>{description}</Typography>
                    </div>
                  </div>
                );
              })}
          </Box>
          <Button className={classes.button} text={buttonText} link={buttonUrl} />
        </Box>

        <Box className={cx(classes.wideImg, 'wide-img-bg')}>
          <LazyLoadImage
            path={desktopImg}
            draggable={false}
            alt={heading}
            srcset={[{ width: 900 }]}
            sizes={`(min-width:${BREAKPOINTS_VALUES['md']}px) 900px`}
            transformation={
              isIE
                ? [
                    {
                      width: 900,
                    },
                  ]
                : null
            }
          />
        </Box>
      </Container>
    </Box>
  );
};

export default WhyUsWideImgBlock;
